import * as React from "react";
import { IRegisteredApplicant } from "../../../../model/applicant/RegisteredApplicant";
import { Descriptions, Row, Col } from "antd";

const ApplicantDetailsOverview = ({
  applicant,
  translate
}: {
  applicant: IRegisteredApplicant;
  translate: any;
}) => {
  return (
    <div>
      <Row>
        <Col span={12}>
          <Descriptions
            column={1}
            bordered
            size={"small"}
            layout={"horizontal"}
          >
            <Descriptions.Item
              label={translate("registered_applicant_page.username")}
            >
              {applicant.username || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.personalID")}
            >
              {applicant.personalID || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.firstName")}
            >
              {applicant.firstName || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.fatherName")}
            >
              {applicant.fatherName || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.lastName")}
            >
              {applicant.lastName || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.motherSurname")}
            >
              {applicant.motherSurname || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.placeOfBirth")}
            >
              {applicant.placeOfBirth || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.name")}
            >
              {applicant.name || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.description")}
            >
              {applicant.description || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.address")}
            >
              <div style={{ whiteSpace: "pre-line" }}>
                {applicant.address ?? "-"}
              </div>
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.phoneNumber")}
            >
              {applicant.phoneNumber || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("registered_applicant_page.email")}
            >
              {applicant.email || "-"}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </div>
  );
};

export default ApplicantDetailsOverview;
